<template>
  <button @click="scrollToTop" ref="scrollTopButton" class="back-top-btn">
    <ion-icon name="caret-up" aria-hidden="true" class="cross"></ion-icon>
  </button>
</template>

<script>
export default {
  name: "DentalTop",
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },

  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    handleScroll() {
      const scrollBtn = this.$refs.scrollTopButton;
      if (window.scrollY > 500) {
        scrollBtn.classList.add("act");
      } else {
        scrollBtn.classList.remove("act");
      }
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>
